import { gql } from "lib/apolloClient";

import { resourceLibraryFragment } from "modules/CommonFragments";

export const updateAssessmentMutation = gql`
  mutation updateAssessment(
    $fields: [UpdatePlannerFieldInput!]
    $updatedBy: ID!
    $assessmentId: ID!
    $enabledSections: AssessmentEnabledSectionsInput
    $academicTermId: ID
    $categoryId: ID
    $globalCategories: UpdateAssessmentGlobalCategoryInput
    $scoreToolData: UpdateAssessmentScoreToolDataInput
    $weightage: Float
    $isLearningGoalsEvaluationEnabled: Boolean
    $courseId: ID
    $unitPlanId: ID
    $isCopyIntoUnitPlan: Boolean
    $isMoveIntoUnitPlan: Boolean
    $isDeleteFromUnitPlan: Boolean
    $isDescriptionUpdateFromAIInput: Boolean = false
  ) {
    planner {
      updateAssessment(
        input: {
          updatedBy: $updatedBy
          fields: $fields
          assessmentId: $assessmentId
          enabledSections: $enabledSections
          academicTermId: $academicTermId
          categoryId: $categoryId
          globalCategories: $globalCategories
          scoreToolData: $scoreToolData
          weightage: $weightage
          isLearningGoalsEvaluationEnabled: $isLearningGoalsEvaluationEnabled
          courseId: $courseId
          unitPlanId: $unitPlanId
          isCopyIntoUnitPlan: $isCopyIntoUnitPlan
          isMoveIntoUnitPlan: $isMoveIntoUnitPlan
          isDeleteFromUnitPlan: $isDeleteFromUnitPlan
        }
      ) {
        id
        assessmentTools {
          edges {
            node {
              id
              assessmentToolItem {
                id
                ... on ScoreAssessmentTool {
                  id
                  scoreToolData {
                    id
                    maxScore
                  }
                }

                ... on AcademicCriteriaSet {
                  id
                  academicCriteriaValues {
                    id
                    label
                    scoreValues {
                      id
                      value
                      minValue
                      maxValue
                      valueType
                      weightageType
                      genericTag {
                        id
                        label
                      }
                    }
                  }
                  criteriaType
                }
              }
              assessmentToolType
              isTeacherEvaluationEnable
              isStudentEvaluationEnable
            }
          }
        }
        enabledSections
        isLearningGoalsEvaluationEnabled
        academicTerm {
          id
          label
        }
        globalCategories {
          id
          name
        }
        category {
          id
          label
          colorCode
          set {
            id
          }
        }
        weightage
        description @include(if: $isDescriptionUpdateFromAIInput) {
          id
          value
        }
      }
    }
  }
`;

export const clearAssessmentToolMutation = gql`
  mutation updateAssessment(
    $updatedBy: ID!
    $assessmentId: ID!
    $clearAssessmentTool: Boolean = true
  ) {
    planner {
      updateAssessment(
        input: {
          updatedBy: $updatedBy
          clearAssessmentTool: $clearAssessmentTool
          assessmentId: $assessmentId
        }
      ) {
        id
        assessmentTools {
          edges {
            node {
              id
              assessmentToolItem {
                id
              }
              assessmentToolType
              isTeacherEvaluationEnable
              isStudentEvaluationEnable
            }
          }
        }
      }
    }
  }
`;

export const createAssessmentMutation = gql`
  mutation createAssessment($input: CreateAssessmentInput!) {
    planner {
      createAssessment(input: $input) {
        ...resourceLibraryItem
      }
    }
  }
  ${resourceLibraryFragment.resourceFeed}
`;

export const deleteAssessmentMutation = gql`
  mutation deleteAssessment($id: ID!) {
    planner {
      deleteAssessment(input: { id: $id })
    }
  }
`;

export const removeAssessmentToolMutation = gql`
  mutation removeAssessmentTool(
    $assessmentId: ID!
    $removeAssessmentToolData: [AssessmentToolInput!]
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM
  ) {
    planner {
      removeToolFromAssessment(
        input: {
          assessmentId: $assessmentId
          removeAssessmentToolData: $removeAssessmentToolData
          parentType: $parentType
        }
      ) {
        warning
        response
      }
    }
  }
`;

export const updateAssessmentToolSettingMutation = gql`
  mutation updateAssessmentToolSetting(
    $toolId: ID!
    $toolType: ASSESSMENT_EVALUATION_TYPE_ENUM!
    $parentId: ID
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM
    $isTeacherEvaluationEnable: Boolean
    $isStudentEvaluationEnable: Boolean
  ) {
    planner {
      updateAssessmentToolSetting(
        input: {
          toolId: $toolId
          toolType: $toolType
          parentId: $parentId
          parentType: $parentType
          isTeacherEvaluationEnable: $isTeacherEvaluationEnable
          isStudentEvaluationEnable: $isStudentEvaluationEnable
        }
      )
    }
  }
`;

export const createCourseFlowResourceMutation = gql`
  mutation createCourseFlowResource(
    $input: CreateLearningCourseFlowResourceInput!
  ) {
    planner {
      createLearningCourseFlowResource(input: $input) {
        __typename
      }
      __typename
    }
  }
`;
